import { helper, http, notify } from "../util";

const controller = "SimpleOrder";

//types
export const RESET_STORE = "RESET_STORE";
export const REQUEST_SIMPLEORDER = "REQUEST_SIMPLEORDER";
export const RECEIVE_SIMPLEORDER = "RECEIVE_SIMPLEORDER";
export const REQUEST_EXTENSIONS_WHITE_LIST = "EXTENSIONS_WHITE_LIST";
export const RECEIVE_EXTENSIONS_WHITE_LIST = "RECEIVE_EXTENSIONS_WHITE_LIST";

//methods
const _resetStore = () => ({ type: RESET_STORE });
export const resetStore = () => (dispatch) => dispatch(_resetStore());

const requestExtensionsWhiteList = () => ({ type: REQUEST_EXTENSIONS_WHITE_LIST })
const receiveExtensionsWhiteList = (payload) => ({ type: RECEIVE_EXTENSIONS_WHITE_LIST, payload })
export const get = () => dispatch => {
    dispatch(requestExtensionsWhiteList());
    return dispatch(() => http.get(helper.getApiPath(controller, 'Get')).then(res => dispatch(receiveExtensionsWhiteList(res))))
}

const requestItem = () => ({ type: REQUEST_SIMPLEORDER });
const receiveItem = (payload) => ({ type: RECEIVE_SIMPLEORDER, payload });
export const submit = data => dispatch => {
    dispatch(requestItem());
    return dispatch(() => http.upload(helper.getApiPath(controller, 'Submit'), data).then(res => {
        if (res?.status === 200)
            notify.show({ message: "کاربر گرامی درخواست شما با موفقیت ثبت شد", type: "success" })
        else if (res?.status === 415)
            notify.show({ message: "نوع فایل بارگذاری شده نامعتبر می باشد", type: "error" })
        dispatch(receiveItem(res));
    }));
}